export function ProfilePage () {
  return (
    <div>
      <h1 className='heading-lg mb-6'>Profile</h1>
    </div>
  )
}
